module.exports = __webpack_public_path__ + "static/media/add_circle_dark.80b0e953.svg";